import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { GetStaffOverallReport } from "../../Repository/Api";
import { NonEmptyValidation } from "../../Store/validate";
import { FinancialMonthOptions, FinancialYearOptions, IsOldReportYear } from "../Common/FinancialYear";
import { generateWordDocument } from "../Common/GenerateReport";
import OverallReport from "../Common/OverallReport";
import { errorMsg, successMsg } from "../Toastify";
const StaffOverallreport = () => {
  const { first_name, desingation, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();

  const initialApplyState = {
    academic_year: [],
    months: [],
  };

  const [apply, setApply] = useState(initialApplyState);
    const [validation, setValidation] = useState({});
  const [appliedReport, setAppliedReport] = useState([]);
  
  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.academic_year = NonEmptyValidation(apply?.academic_year);
    if (!IsOldReportYear(apply)) {
      validate.months = NonEmptyValidation(apply?.months);
    }
    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...apply,
        months: apply?.months?.map((date) => date.value) || 0,
      };
      const response = await GetStaffOverallReport(Payload, token);
      if (response && response.statusCode === 200) {
        setAppliedReport(response.data);
        successMsg(response.message);
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-4">
                    <h6 className="labeltitle">
                      <span
                        className="arrowicon"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        ← &nbsp;
                      </span>Overall Appraisal Report</h6>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3">
                    <label className="labeltext"> Academic Year *</label>
                    <div>
                      <ReactSelect
                        isMulti={false}
                        value={{
                          label: apply.academic_year,
                          value: apply.academic_year,
                        }}
                        onChange={(selectedOption) =>
                          setData(selectedOption.value, "academic_year")
                        }
                        options={FinancialYearOptions()}
                        placeholder="Select Year"
                      />
                    </div>
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>
                  {!IsOldReportYear(apply) && (
                    <div className="col-lg-3">
                      <label className="labeltext"> Month *</label>
                      <div>
                        <ReactSelect
                          isMulti
                          value={apply?.months}
                          onChange={(e) => {
                            setData(e, "months");
                          }}
                          options={
                            apply?.months?.some((v) => v?.value === "all")
                              ? [{ label: "All", value: "all" }]
                              : FinancialMonthOptions(apply)
                          }
                        />
                      </div>
                      <small className="validationerror">
                        {validation?.months?.message
                          ? `Month ${validation?.months?.message}`
                          : ""}
                      </small>
                    </div>
                  )}
                  <div className="col-lg-3 centertext mt-5">
                    <button
                      type="submit"
                      className="requestbtn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Get Report
                    </button>
                  </div>
                  <div className="col-lg-3 centertext mt-5">
                    <button
                      type="submit"
                      className="requestbtn"
                      onClick={() => generateWordDocument(appliedReport, IsOldReportYear(apply), apply)}
                    >
                      Generate Report
                    </button>
                  </div>
                </div>
                <OverallReport
                  appliedReport={appliedReport}
                  isOldReportYear={IsOldReportYear(apply)}
                  apply={apply}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffOverallreport;
